import React, {useRef, useState} from "react";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import AppStateModel from "../../../models/appStateModel";
import {useDispatch, useSelector} from "react-redux";
import LookupModel from "../../../models/lookupModel";
import Select from "react-select";
import {setShipmentsCriteriaAsync} from "../../../actions/shipmentsActions";
import ShipmentModel from "../../../models/shipmentModel";
import Form from "react-bootstrap/Form";
import ReactSelect from "react-select";

interface IProps {
    visible: boolean;
    onHide: () => any;
    onDone: (ids: string[], customerId: string, stationId: string) => void;
    title: string;
    submitButton: string;
    selectedIds: string[];
    allowedStatuses?: string[];
}

const BulkStoredModal = (props: IProps) => {
    const [location, setLocation] = useState<string>("")
    const [shipments, setShipments] = useState<Array<ShipmentModel>>([])
    const dispatch = useDispatch()
    const ref = useRef<any>(null)
    const stationsOptions = useSelector(
        (state: AppStateModel) => state.Meta?.stations
    );
    const profile = useSelector((state :AppStateModel)=>state.Profile)
    const [showShipments, setsShowShipments] = useState(false)
    const [stations, setStations] = React.useState<any>();
    React.useEffect(() => {
        (profile.stationId !=null && setStations(stationsOptions?.find((x) => x.value == profile.stationId)))
    }, [profile.stationId, stationsOptions]);
    const onSubmit = () => {
        props.onDone(props.selectedIds, location, stations.value);
    };
    const onKeyPressLocation = (e: any) => {
        if (e.keyCode === 13) {
            setsShowShipments(true)
        }
    };

    return (
        <Modal
            show={props.visible}
            onHide={() => props.onHide()}
            dialogClassName="modal-100w"
            aria-labelledby="example-custom-modal-styling-title"
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{display:"flex", flexDirection:"column", gap:5}}>
                <div style={{ width: '40%' }}>
                    <label>Location</label>
                    <Form.Control
                        placeholder="Location"
                        value={location}
                        onChange={(e: any) => setLocation(e.target.value)}
                        onKeyDown={onKeyPressLocation}
                        autoFocus={true}
                        ref={ref}
                    />
                </div>
                <div style={{ width: "20%" }}>
                    <ReactSelect
                        placeholder="Select station.."
                        value={stations}
                        onChange={(v) => setStations(v)}
                        options={stationsOptions}
                        isDisabled={profile.stationId!=null}
                    />
                </div>
                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button

                    onClick={props.onHide}
                >
                    Close
                </Button>
                <Button

                    onClick={onSubmit}
                >
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BulkStoredModal;